import { formStructureApi } from "api/TenantSlug/FormStructure/api.ts";
import { buildFormFieldsByTag } from "components/UI/BaseFilter/utils/formStructureFieldsCategory";
import { useFetchAllPaginatedData } from "hooks/useFetchAllPaginatedData.ts";
import { useMemo } from "react";

import FormStructureData = App.Data.FormStructureData;

/** Loads the given form structures together with their fields (source of the "Lead data" picker). */
export const useFilterFormStructures = (structureIds: string[]) => {
    const query = useFetchAllPaginatedData(
        (payload) => formStructureApi.index(payload),
        { filter: { filter: { id: { in: structureIds } }, include: "formFields" } },
        "formStructures",
        { enabled: structureIds.length > 0 }
    );

    const formStructures = (structureIds.length > 0 ? (query.data ?? []) : []) as FormStructureData[];
    const loaded = query.data;

    // Undefined only while the structures load, so a field rule is never reported as missing just because its
    // structure has not arrived. Without any structure (or field) it is an empty set: every field rule is then wrong.
    const fieldTags = useMemo(() => {
        if (structureIds.length === 0) {
            return new Set<string>();
        }
        return loaded ? new Set(buildFormFieldsByTag(loaded as FormStructureData[]).keys()) : undefined;
    }, [loaded, structureIds.length]);

    return { formStructures, fieldTags, isLoading: query.isLoading };
};
